module.exports = __webpack_public_path__ + "img/responsive3.886fb8d2.svg";